import { PopoverBody, UncontrolledPopover } from 'reactstrap';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { GrievanceItem } from '../../services/types/Grievance';
import GeneralInfoItem from '../Operations/Operation/GeneralInfoItem';
import { UIKitBadge } from '../../shared/UIKITComponents/Badge';
import { customDateStr } from '../../shared/misc/utils';
import UIKitLink from '../../shared/UIKITComponents/Link';

interface Props {
  grievance: GrievanceItem;
}
const GIMICIInfo: React.FC<Props> = ({ grievance }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const rows = grievance.miciHighlightDataRows || [];

  const renderPopoverLinks = (miciStatus?: string) => {
    const filteredRows = miciStatus
      ? rows.filter((x) => x.status === miciStatus || (miciStatus === 'Closed' && x.closingDate))
      : rows;

    if (filteredRows.length === 0) {
      return <span />;
    }

    return filteredRows.map((x) => (
      <Fragment key={`${miciStatus || 'all'}-${x.id}-${x.number}`}>
        <div className="d-flex flex-row mici-data-item">
          <div className="text-nowrap-link">
            <UIKitLink
              size="medium"
              onClick={() => navigate(`/mici-cases/${x.number}`)}
              text={x.number}
            />{' '}
          </div>
          {miciStatus === 'Closed' && x.closingDate && (
            <div className="text-nowrap">
              Date: <b>{customDateStr(x.closingDate)}</b>
            </div>
          )}
        </div>
      </Fragment>
    ));
  };

  const renderMiciBlock = (titleKey: string, id: string, status?: string, subtitle?: string) => {
    const count = status
      ? rows.filter((x) => x.status === status || (status === 'Closed' && x.closingDate)).length
      : rows.length;

    const hasData = count > 0;

    return (
      <GeneralInfoItem title={t(titleKey)}>
        <>
          <div
            id={id}
            style={{
              cursor: hasData ? 'pointer' : 'default',
              display: 'inline-block',
            }}
          >
            <UIKitBadge color="primary" variant="standard">
              {count || '0'}
            </UIKitBadge>
          </div>

          {hasData && (
            <UncontrolledPopover
              placement="bottom"
              target={id}
              trigger="legacy hover focus"
              className="popover-gantt mici-popover"
            >
              <PopoverBody className="mici-popover">
                <h5 className="mici-popover-title">{subtitle}</h5>
                {renderPopoverLinks(status)}
              </PopoverBody>
            </UncontrolledPopover>
          )}
        </>
      </GeneralInfoItem>
    );
  };

  return (
    <div className="gi-items table-responsive">
      {renderMiciBlock('miciTotal', 'mici-total', undefined, 'Total Cases')}
      {renderMiciBlock('miciActive', 'mici-active', 'Active', 'Active Cases')}
      {renderMiciBlock('miciClosed', 'mici-closed', 'Closed', 'Close Date')}
    </div>
  );
};
export default GIMICIInfo;
